import { useContext } from "react";
import { OnboardingChecklistContext } from "../contexts/OnboardingChecklistContext";

const useOnboardingChecklist = () => {
  const context = useContext(OnboardingChecklistContext);

  if (!context) {
    throw new Error(
      "useOnboardingChecklist must be used within OnboardingChecklistProvider"
    );
  }

  return context;
};

export default useOnboardingChecklist;
